import { ElementHelpers } from './element-helpers';
import { EventEmitter } from '../components/event-emitter';

/* globals _st */
export class Analytics {

	constructor(documentRoot = document) {
		this.document = documentRoot;
		Analytics.initTrackLinkClicks(this.document);
		// this.initTrackFormSubmit();
		this.initTrackJobBoard();
		this.trackPageLoadEvents();
		this.trackViewEvents();
	}


	static initTrackLinkClicks(target = document) {
		const analyticsLinks = target.querySelectorAll(`[${Analytics.analyticsTags.category}]`);
		for (let i = 0; i < analyticsLinks.length; i = i + 1) {
			analyticsLinks[i].addEventListener('click', (event) => {
				const isExternal = ElementHelpers.isExternalLink(event.currentTarget),
					openInNewTab = Analytics.openInNewTab(event);

				let preventdefault = isExternal && !openInNewTab;

				if (event.currentTarget) {
					let attribute = event.currentTarget.getAttribute(Analytics.analyticsTags.preventdefault);
					preventdefault = attribute !== null && attribute !== 'false';
				}

				if (preventdefault) {
					event.preventDefault();
				}

				Analytics.handleLinkClick(event.currentTarget, preventdefault);
			});
		}
	}

	// initTrackFormSubmit() {
	// 	const forms = this.document.querySelectorAll(`form[${Analytics.analyticsTags.form.category}]`);
	// 	for (let i = 0; i < forms.length; i = i + 1) {
	// 		forms[i].addEventListener('submit', (event) => {
	// 			Analytics.handleFormSubmit(event.currentTarget);
	// 		});
	// 	}
	// }

	initTrackJobBoard() {
		const measureJobs = function (jobs, eventName = 'load') {
			const jobsData = jobs.filter(job => {
				return !job.hasAttribute('data-analytics-measured');
			}).map(job => {
				job.setAttribute('data-analytics-measured', true);
				try {
					return JSON.parse(job.getAttribute(Analytics.analyticsTags.job));
				} catch (e) {
					console.error('No valid analytics data for job:', job);
				}
			});
			if (jobsData.length >= 1) {
				Analytics.measure(jobsData, null, eventName, '_joblisting', false);
			}
		};

		const board = document.querySelector(`[${Analytics.analyticsTags.jobBoard}]`) || document.querySelector(`[${Analytics.analyticsTags.savedVacancies}]`);

		if (board) {

			let jobs = ElementHelpers.getElementsAsArray(`[${Analytics.analyticsTags.job}]`) || '',
				visibleJobs;

			// Measure stuff on load
			jobs = ElementHelpers.getElementsAsArray(`[${Analytics.analyticsTags.job}]`);
			visibleJobs = jobs.filter(job => ElementHelpers.isHalfWayInsideViewport(job));
			measureJobs(visibleJobs, 'scroll');

			// Measure stuff when data is loaded
			EventEmitter.on('LazyloadBoard:getData', () => {
				jobs = ElementHelpers.getElementsAsArray(`[${Analytics.analyticsTags.job}]`);
				visibleJobs = jobs.filter(job => ElementHelpers.isHalfWayInsideViewport(job));
				measureJobs(visibleJobs, 'scroll');
			});

			let timeout;
			let delay = Number(board.getAttribute('data-analytics-jobboard-delay')) || 2000;

			// Measure when user has scrolled
			EventEmitter.on('ScrollDetector:scroll', () => {
				if (!timeout) {
					timeout = setTimeout(() => {
						if(jobs){
							visibleJobs = jobs.filter(job => ElementHelpers.isHalfWayInsideViewport(job));
							measureJobs(visibleJobs, 'scroll');
							timeout = null;
						}
					}, delay);
				}
			});
		}
	}

	// @TODO: Refactor the code since it's almost the same as initTrackJobboard
	trackViewEvents() {
		const measureElements = function (elements, eventName = 'scroll') {
			const elementData = elements.filter(element => {
				return !element.hasAttribute('data-analytics-measured');
			}).map(element => {
				element.setAttribute('data-analytics-measured', true);
				try {
					return JSON.parse(element.getAttribute(Analytics.analyticsTags.view));
				} catch (e) {
					console.error('No valid analytics data for element:', element);
				}
			});
			if (elementData.length >= 1) {
				// _st.event isn't always fully initialized when this script is fired, that's why we can also use the 'old' way: _st('publishEvent', '_trackEvent', data);
				elementData.forEach(data => {
					if (_st.event) {
						Analytics.measure(data, null, eventName, '_trackEvent', false);
					} else if (_st) {
						_st('publishEvent', '_trackEvent', eventName, data);
					}
				})
			}
		};

		let elements = ElementHelpers.getElementsAsArray(`[${Analytics.analyticsTags.view}]`) || '',
			visibleElements;
		visibleElements = elements.filter(element => ElementHelpers.isHalfWayInsideViewport(element));
		measureElements(visibleElements, 'load');

		let timeout;
		let delay = 2000;

		// Measure when user has scrolled
		EventEmitter.on('ScrollDetector:scroll', () => {
			if (!timeout) {
				timeout = setTimeout(() => {
					if(elements){
						visibleElements = elements.filter(element => ElementHelpers.isHalfWayInsideViewport(element));
						measureElements(visibleElements, 'scroll');
						timeout = null;
					}
				}, delay);
			}
		});

	}



	trackPageLoadEvents() {

		const parentElement = document.querySelectorAll(`[${Analytics.analyticsTags.load}]`);

		for (let i = 0; i < parentElement.length; i++) {
			const element = parentElement[i];
			let analyticsCategory;
			const childElements = element.querySelectorAll(`[${Analytics.analyticsTags.category}]`);
			const amount = childElements.length;
			if(amount > 0) {
				analyticsCategory = childElements[0].getAttribute(Analytics.analyticsTags.category);
			}

			if(amount && analyticsCategory) {
				const data = {
					category: analyticsCategory,
					action: 'load',
					label: amount
				};
				// _st.event isn't always fully initialized when this script is fired, that's why we can also use the 'old' way: _st('publishEvent', '_trackEvent', data);
				if(_st.event){
					Analytics.measure(data, '', 'load');
				}else if(_st) {
					_st('publishEvent', '_trackEvent', 'load', data);
				}
			}
		}
	}

	static handleFormSubmit(form, callback) {
		Analytics.measure({
			category: form.getAttribute(Analytics.analyticsTags.form.category),
			label: `${form.getAttribute(Analytics.analyticsTags.form.label)}_${Analytics.dataToString(Analytics.getFormData(form))}`,
			action: form.getAttribute(Analytics.analyticsTags.form.action),
			value: Analytics.dataToString(Analytics.getFormData(form))
		}, callback);
	}

	/**
	 * Handler for a simple click link to an external url
	 *
	 * @param target
	 * @param defaultPrevented
	 */
	static handleLinkClick(target, defaultPrevented) {

		const curPath = window.location.pathname;
		let action = target.getAttribute(Analytics.analyticsTags.action) || curPath,
			category = target.getAttribute(Analytics.analyticsTags.category),
			label = target.getAttribute(Analytics.analyticsTags.label) || Analytics.defineAnchorLabel(target) || '';

		const data = {
			action: action || '',
			category: category || '',
			label: label,
			value: target.getAttribute(Analytics.analyticsTags.value) || target.innerText || ''
		};
		const callback = () => {
			if (defaultPrevented) {
				window.location = target.href;
			}
		};
		const eventType = target.getAttribute(Analytics.analyticsTags.eventType) || undefined;
		Analytics.measure(data, callback, undefined, eventType);
	}

	static defineAnchorLabel(target) {
		const curHost = window.location.host;
		const noHrefLabel = 'No href';
		const href = target.getAttribute('href');

		if (!href) {
			return noHrefLabel;
		} else {
			if (href.substring(0, 2) === '//' && href.indexOf(curHost) > -1) {
				return target.pathname;
			}

			if (href.indexOf(curHost) > -1) {
				return target.pathname;
			}

			if (href.charAt(0) === '/' && href.substring(0, 2) !== '//') {
				return target.pathname;
			}

			if (href[0] === '#') {
				return href;
			}
			return 'External';
		}
	}

	/**
	 * Static html attribute tags
	 *
	 * @returns {{action: string, category: string, label: string, value: string}}
	 */
	static get analyticsTags() {
		return {
			action: 'data-analytics-action',
			category: 'data-analytics-category',
			component: 'data-analytics-component', // Created a new data-analytics-component to target this category used for elements which has no click event and should be measured via other Js scripts than Analytics.js
			label: 'data-analytics-label',
			value: 'data-analytics-value',
			preventdefault: 'data-analytics-preventdefault',
			eventType: 'data-analytics-eventtype',
			form: {
				action: 'data-form-action',
				category: 'data-form-category',
				label: 'data-form-label'
			},
			jobBoard: 'data-analytics-jobboard',
			savedVacancies: 'data-analytics-saved-vacancies',
			job: 'data-analytics-job',
			load: 'data-analytics-load',
			view: 'data-analytics-view'
		};
	}

	/**
	 * Function to measure data with Relay42
	 *
	 * @param data
	 * @param callback
	 * @param eventName
	 * @param eventType
	 * @param formatData
	 */
	static measure(data, callback, eventName = 'click', eventType = '_trackEvent', formatData = true) {
		if (typeof _st !== 'undefined' && _st.event) {
			let measurementData = {};

			measurementData = this.setMeasurementData(formatData, measurementData, data);

			if (callback) {
				measurementData.callback = callback;
			}
			_st.event.publish(eventType, eventName, measurementData);
			setTimeout(callback, 100);
		} else if (callback) {
			callback();
		}
	}

	static setMeasurementData(formatData, measurementData, data) {
		if (formatData) {
			const page = window.location.pathname + window.location.search + window.location.hash;

			measurementData = {
				action: data.action || page,
				category: data.category || '',
				label: data.label || '',
				value: data.value || ''
			};
		} else {
			measurementData = data;
		}
		return measurementData;
	}

	static concatString(string, append, delimiter = '_') {
		const array = [];
		array.push(string);

		if (append) {
			array.push(append);
		}

		return array.join(delimiter);
	}

	static dataToString(data) {
		if (Array.isArray(data)) {
			let dataString = '';

			for (const key in data) {
				dataString = Analytics.concatString(dataString, `${key}=${data[key]}`, '&');
			}

			return dataString;
		} else if (typeof data === 'string') {
			return data;
		}
		return '';
	}

	static getFormData(form) {
		let data = [];

		const formElems = form.elements;

		for (let e = 0; e < formElems.length; e = e + 1) {
			data.push(`${formElems[e].name}=${formElems[e].value}`);
		}

		return data.join('&');
	}

	/**
	 * checks whether or not the user wants to open a new tab on click
	 */
	static openInNewTab(event) {
		// ctrl + click on windows open in new tab
		// metaKey + click on mac open in new tab
		// target _blank
		const target = event.currentTarget.getAttribute('target') || '';
		return (target === '_blank') || event.ctrlKey || event.metaKey;

	}
}
